import { useEffect, useState } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
const UpdateCenter = ({ vehiclesPosition, centerToBusLive, setCenterToBusLive, points, isMobile, centerMapAt, busOnFocusID }) => {
  const [zoomLevel, setZoomLevel] = useState(isMobile ? 14.5 : 16);
  const map = useMap();

  map.zoomControl.setPosition('bottomleft');
  map.setMinZoom(isMobile ? 13 : 14);

  const eventsMap = useMapEvents({
    zoomend: () => {
      //   setCenterToBusLive(false);
      centerToBusLive && setZoomLevel(map.getZoom());
    },
  });

  // if no vehicles are on the map, center the map to the middle point of the route
  useEffect(() => {
    if (Array.isArray(vehiclesPosition) && vehiclesPosition.length === 0) {
      if (Array.isArray(points) && points.length > 0) {
        map.setView(centerMapAt, isMobile ? 14 : 15);
      }
    }
  }, [points]);

  // if a bus is selected, center the map to the bus
  useEffect(() => {
    if (Array.isArray(vehiclesPosition) && vehiclesPosition.length > 0 && busOnFocusID) {
      let [busOnFocus] = vehiclesPosition.filter((item) => {
        return item.vehicleCode === busOnFocusID;
      });
      centerToBusLive && busOnFocus && map.setView([busOnFocus.latitude, busOnFocus.longitude], zoomLevel);
    }
  }, [centerToBusLive, vehiclesPosition, busOnFocusID]);

  // if the map is dragged, disable the centering to the bus
  map.on('dragstart', (e) => {
    if (e.hard) {
      // moved by bounds
    } else {
      setCenterToBusLive(false);
    }
  });

  return <></>;
};

export default UpdateCenter;
